"use client";

import { FlaskConical, LayoutDashboard } from "lucide-react";
import { WorkspaceLayout } from "@/components/layout/workspace-layout";
import { WorkspaceCards } from "@/components/layout/workspace-cards";

export default function HomePage() {
  return <WorkspaceLayout area="home">
    <header>
      <h1 className="text-2xl font-semibold tracking-tight">Choose Your Workspace</h1>
      <p className="mt-2 text-sm text-muted">Monitor your Azure resources or explore interactive AI demos.</p>
    </header>
    <WorkspaceCards items={[
      { title: "Studio", description: "Explore resource monitoring, model usage, and your Azure workspace.", href: "/studio", action: "Open Studio", icon: LayoutDashboard },
      { title: "Demo", description: "Try hands-on AI experiences with your own Azure resources.", href: "/demo", action: "Open Demo", icon: FlaskConical },
    ]} />
  </WorkspaceLayout>;
}
